import { ISalvarAvaliacaoCSATGateway } from "./SalvarAvaliacaoCSATGateway";

export enum CSATGatewayHandlers {
  minhasEmpresas = "minhasEmpresas"
}

export interface ICSATHandler<T> {
  seNext(next: ICSATHandler<T>): ICSATHandler<T>;
  handle(tipo: CSATGatewayHandlers): null | ISalvarAvaliacaoCSATGateway<T>;
}
